import BannerSection from '@/components/BannerSection/BannerSection';
import { setBannerCart } from '@/utils/homePageCmsCall';
import { sortArray } from '@/utils/index.js';
import ProductsAisle from '../ProductsAisle/ProductsAisle';
import { aislesViewAnalyticsFunction } from '@/utils/analytics.js';

export const setLayout = (item, index, isMobile, defaultProductImage, sessionId) => {
  switch (index) {
    case 0:
      let list =
        item?.data?.length > 0 && item?.data[0]
          ? sortArray(item.data[0].content.banners, item?.included?.cart_banner)
          : [];

      let products = list.map(el => el.content.sidesheet_products);
      let titles = list.map(el => el.content.title);
      if (list.length > 0) {
        const images = setBannerCart(list);
        return (
          <BannerSection
            images={images}
            fixedWidth={false}
            showPagination={false}
            products={products}
            titles={titles}
            type={images?.length > 1 ? 'loop' : 'slide'}
            defaultProductImage={defaultProductImage}
          />
        );
      } else {
        return <></>;
      }

    case 1:
      if (item?.data) {
        if (item?.data?.length > 0) {
          const productsSku = item.data[0].content.products_andor_offers
            .filter(prod => prod !== null)
            .map(prod => {
              return prod.replace('PR', '');
            });
          return (
            <>
              <ProductsAisle
                isMobile={isMobile}
                products={productsSku}
                title={item.data[0].content.title}
                linkText={item.data[0].content.redirection_text}
                productsLink={item.data[0].content.redirection_url}
                hasPadding={true}
                limitations={item.data[0].content.limitations}
                hideLastTile={
                  !item.data[0].content?.redirection_text || item.data[0].content?.redirection_text?.length === 0
                }
                defaultProductImage={defaultProductImage}
                analyticsFunction={(products, list) => aislesViewAnalyticsFunction(products, list, sessionId)}
                list={'recommended_products'}
              />
            </>
          );
        }
      } else {
        return <></>;
      }
  }
};
